<template>
    <div class="mortgage-status-setting">
				<StatusMenu :tab_name="'mortgageStatus'"  v-if="_gAuth.isAppSas()"/>
        <CreateNewMortgageStatusModal :create_new_mortgage_status.sync="modals.create_new_mortgage_status"  v-on:closeModal="closeModal()"  />
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Mortgage Status Setting</h2>
                </b-col>
                <b-col cols="6" class="text-right ">
                    <b-button variant="primary" class="btn-header" @click="openModal">Create New</b-button>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <MortgageStatusTable />
        </b-container>
    </div>
</template>
<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import StatusMenu from '@/views/Configurations/StatusMenu'
import MortgageStatusTable from '@/views/Configurations/MortgageStatusSettings/MortgageStatusTable'
import CreateNewMortgageStatusModal from '@/views/Configurations/MortgageStatusSettings/MortgageStatusModals/CreateNewMortgageStatusModal'

export default {
    components: {
        MortgageStatusTable,
        RouteBreadCrumb,
        CreateNewMortgageStatusModal,
				StatusMenu
    },
    data() {
        return {
            modals: {
                create_new_mortgage_status: false
            }
        }
    },
    methods: {
        openModal() {
            this.modals.create_new_mortgage_status = true;
        },
        closeModal(){
            this.modals.create_new_mortgage_status = false;
        },
    }
}
</script>